@use "@flixbus/honeycomb-react/dist/scss/honeycomb-helpers.scss";

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--hcr-spacing-1);
  padding: var(--hcr-spacing-4) 0;
}

.icon {
  width: 32px;
  height: 32px;
  color: var(--hcr-content-secondary-color);
}
